/**
 *
 * Asynchronously loads the component for PostSessionAssessment
 *
 */

import loadable from 'loadable-components';

export default loadable(() => import('./index'));
